import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  AppBar,
  Modal,
  Toolbar,
  Button,
  Grid,
  Paper,
  Box,
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function EditFine() {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [feeType, setFeeType] = useState([]);
  const [month, setMonth] = useState([]);
  const [loadingBarProgress, setLoadingBarProgress] = useState('');
  const [selectedValue, setSelectedValue] = useState('');
  const [selectedFee, setSelectedFee] = useState('');
  const [formData, setFormData] = useState({
    feeTypeId: '',
    fineFor: '',
    startDate: '',
    endDate: '',
    finePerDay: '',
    remark: '',
  });
  const [isCancelClicked, setIsCancelClicked] = useState(false);
  const { fineId } = useParams();
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'finePerDay') {
      // Prevent negative values
      if (value < 0) return;
    }

    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const isFormFilled = () => {
    return Object.values(formData).some((value) => value !== '') || selectedFee !== '' || selectedValue !== '';
  };

  const handleCancel = () => {
    navigate(-1);
    // if (isCancelClicked) {
    //   navigate('/Settings/FrmDueDate.aspx/:encodedFormId'); // Navigate back to fine page
    // } else if (isFormFilled()) {
    //   // Clear all fields
    //   setFormData({
    //     feeTypeId: '',
    //     fineFor: '',
    //     startDate: '',
    //     endDate: '',
    //     finePerDay: '',
    //     remark: '',
    //   });
    //   setSelectedFee('');
    //   setSelectedValue('');
    //   setIsCancelClicked(true);
    // } else {
    //   navigate('/Settings/FrmDueDate.aspx/:encodedFormId'); // Navigate back if form is empty
    // }
  };

  const handleSubmit = async () => {
    // Validate dates
    if (formData.startDate && formData.endDate) {
      const startDate = new Date(formData.startDate);
      const endDate = new Date(formData.endDate);

      if (endDate <= startDate) {
        // alert('End date must be after start date');
        setSnackbarMessage('End date must be after start date');
        setOpenSnackbar(true);
        setSnackbarSeverity("warning");
        return;
      }
    }

    try {
      const token = sessionStorage.getItem('token');
      const apiUrl = process.env.REACT_APP_BASE_URL;

      // Format dates to dd/mm/yyyy
      const formattedStartDate = formData.startDate.split('-').reverse().join('/');
      const formattedEndDate = formData.endDate.split('-').reverse().join('/');

      // Update formData with formatted dates and ensure remark is included
      const updatedFormData = {
        ...formData,
        feeTypeId: selectedFee,
        fineFor: selectedValue,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        remark: formData.remark || '', // Ensure remark is included
      };

      const response = await fetch(`${apiUrl}/Fine/Id?Id=${fineId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(updatedFormData),
      });

      if (response.ok) {
        // Clear form after successful save
        // setFormData({
        //   feeTypeId: '',
        //   fineFor: '',
        //   startDate: '',
        //   endDate: '',
        //   finePerDay: '',
        //   remark: '',
        // });
        // setSelectedFee('');
        // setSelectedValue('');
        setLoadingBarProgress(100);
        setIsCancelClicked(false);
        setShowSuccessModal(true);

      } else {
        setLoadingBarProgress(0);
        // alert('Failed to update fine');
        setSnackbarMessage('Failed to update fine');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      }
    } catch (error) {
      console.error('API request error:', error);
      // alert('An error occurred. Please try again later.');
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  const fetchddlFeeType = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/Fine/GetChargeType`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        // alert(`Error fetching fee types: ${response.status}`);
        setSnackbarMessage(`Error fetching fee types: ${response.status}`);
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      }
      const data = await response.json();
      if (data.data === null && data.msg === 'Record Not Found') {
        throw new Error('Record Not Found');
      }
      setFeeType(data);
    } catch (error) {
      // alert(error);
      setSnackbarMessage(error);
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  const fetchMonth = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/Fine/GetMonthList`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        // alert(`Error fetching months: ${response.status}`);
        setSnackbarMessage(`Error fetching months: ${response.status}`);
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      }
      const data = await response.json();
      if (data.data === null && data.msg === 'Record Not Found') {
        throw new Error('Record Not Found');
      }
      setMonth(data);
    } catch (error) {
      // alert(error);
      setSnackbarMessage(error);
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
    }
  };

  useEffect(() => {
    fetchddlFeeType();
    fetchMonth();
  }, []);

  useEffect(() => {
    const fetchFineData = async () => {
      try {
        const apiUrl = process.env.REACT_APP_BASE_URL;
        const token = sessionStorage.getItem('token');
        const response = await fetch(`${apiUrl}/Fine/GetFine`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: token,
          },
          body: JSON.stringify({}),
        });
        if (!response.ok) {
          // alert(`Error fetching fine data: ${response.status}`);
          setSnackbarMessage(`Error fetching fine data: ${response.status}`);
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
        }
        const data = await response.json();
        if (data.data === null && data.msg === 'Record Not Found') {
          throw new Error('Record Not Found');
        }
        const fine = data.find((item) => item.dueDateId === parseInt(fineId));
        if (fine) {
          // Format dates to yyyy-mm-dd for TextField component
          const formattedStartDate = fine.startDate.split('/').reverse().join('-');
          const formattedEndDate = fine.endDate.split('/').reverse().join('-');

          // Populate formData with the fetched fine data
          setFormData({
            feeTypeId: fine.chargeTypeId,
            fineFor: fine.monthId,
            startDate: formattedStartDate,
            endDate: formattedEndDate,
            finePerDay: fine.finePerDay,
            remark: fine.remark || '',
          });
          setSelectedFee(fine.chargeId);
          setSelectedValue(fine.monthId);
        } else {
          // alert('Fine not found');
          setSnackbarMessage('Fine not found');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
        }
      } catch (error) {
        // alert(error);
        setSnackbarMessage(error);
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      }
    };
    fetchFineData();
  }, [fineId]);

  return (
    <Container >
      <AppBar position="static" style={{ backgroundColor: '#0B1F3D' }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Edit Fine
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>
        <Box p={3}>
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel htmlFor="feeTypeSelect">Fee Type</InputLabel>
                  <Select
                    id="feeTypeSelect"
                    label="Fee Type"
                    value={selectedFee}
                    onChange={(e) => {
                      setSelectedFee(e.target.value);
                      setFormData((prev) => ({ ...prev, feeTypeId: e.target.value }));
                    }}
                    fullWidth
                  >
                    <MenuItem value="">Select Fee Type</MenuItem>
                    {feeType.map((item) => (
                      <MenuItem key={item.chargeTypeId} value={item.chargeTypeId}>
                        {item.chargeType}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id="fineForSelect">Fine For</InputLabel>
                  <Select
                    id="fineForSelect"
                    label="Fine For"
                    value={selectedValue}
                    onChange={(e) => {
                      setSelectedValue(e.target.value);
                      setFormData((prev) => ({ ...prev, fineFor: e.target.value }));
                    }}
                    fullWidth
                  >
                    <MenuItem value="">Select Month</MenuItem>
                    {month.map((item) => (
                      <MenuItem key={item.monthId} value={item.monthId}>
                        {item.month}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  type="date"
                  label="Start Date"
                  InputLabelProps={{ shrink: true }}
                  name="startDate"
                  value={formData.startDate}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  type="date"
                  label="End Date"
                  InputLabelProps={{ shrink: true }}
                  name="endDate"
                  value={formData.endDate}
                  onChange={handleInputChange}
                  inputProps={{
                    min: formData.startDate ? new Date(new Date(formData.startDate).getTime() + 86400000).toISOString().split('T')[0] : undefined,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  type="number"
                  label="Fine Per Day"
                  name="finePerDay"
                  value={formData.finePerDay}
                  onChange={handleInputChange}
                  inputProps={{ min: 0 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  type="text"
                  label="Remark"
                  name="remark"
                  value={formData.remark}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12}>
                <Button variant="contained" color="primary" onClick={handleSubmit}>
                  Save
                </Button>
                <Button variant="contained" color="error" style={{ marginLeft: '10px' }} onClick={handleCancel}>
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Paper>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Fine Updated ✅
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              The Fine has been Updated successfully.
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1); // go back after closing modal
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
}

export default EditFine;
